import materialsHtml from './materials.html';
import materialsService from './materials.service';

class materialController {
    constructor($scope, $timeout, materialsService) {
        'ngInject';

        this.saving = false;
        this.saved = true;
        this.savedAlert = false;
        this.service = materialsService;
        this.model = [];
        this.priceGroups = [];
        this.languages = [];
        this.shops = [];

        this.service.getMaterials().then(
            response => {
                this.model = response.data;
                for (let item of this.model) {
                    if (!item.cutPrices) {
                        continue;
                    }

                    for (let key in item.cutPrices) {
                        if (key.includes('Available') && item.cutPrices[key] === true) {
                            item.cutPrices[key] = '1';
                        }
                    }
                }

                for (let item of this.model) {
                    if (!item.availableHoleTypes) {
                        continue;
                    }

                    for (let cutType in item.availableHoleTypes) {
                        for (let shape in item.availableHoleTypes[cutType]) {
                            if (item.availableHoleTypes[cutType][shape] === true) {
                                item.availableHoleTypes[cutType][shape] = '1';
                            }
                        }
                    }
                }

                for (let item of this.model) {
                    if (!item.availableMainShapes) {
                        continue;
                    }

                    for (let cutType in item.availableMainShapes) {
                        for (let shape in item.availableMainShapes[cutType]) {
                            if (item.availableMainShapes[cutType][shape] === true) {
                                item.availableMainShapes[cutType][shape] = '1';
                            }
                        }
                    }
                }
            },
            response => {
                alert("Wystąpił nieoczekiwany błąd! Skontaktuj się z administratorem.");
            }
        );

        this.service.getPriceGroups().then(
            response => {
                this.priceGroups = response.data;
            },
            response => {
                alert("Wystąpił nieoczekiwany błąd! Skontaktuj się z administratorem.");
            }
        );

        this.service.getLanguages().then(
            response => {
                this.languages = response.data;
            },
            response => {
                alert("Wystąpił nieoczekiwany błąd! Skontaktuj się z administratorem.");
            }
        );

        this.service.getShops().then(
            response => {
                this.shops = response.data;
            },
            response => {
                alert("Wystąpił nieoczekiwany błąd! Skontaktuj się z administratorem.");
            }
        );
    }

    save() {
        this.saving = true;

        this.service.saveMaterials(this.model).then(
            response => {
                this.saving = false;
                this.saved = true;
                this.savedAlert = true;
                this.model = response.data;
            },
            response => {
                this.saving = false;
                this.saved = false;
                this.savedAlert = false;
                alert("Nie udało się zapisać danych! Skontaktuj się z administratorem.");
            }
        );
    }

    migrateCutCosts() {
        for (const item of this.model) {
            for (const subitem of item.items) {
                if (subitem.id === 2) {
                    continue;
                }

                if (subitem.items.length === 0) {
                    const similarCutCosts = this.findSimilarCutCosts(subitem);

                    if (similarCutCosts !== false) {
                        this.migrateCutCost(similarCutCosts, subitem);
                    }
                } else {
                    for (const size of subitem.items) {
                        const similarCutCosts = this.findSimilarCutCosts(size);

                        if (similarCutCosts !== false) {
                            this.migrateCutCost(similarCutCosts, size);
                        }
                    }
                }
            }
        }

        let migratePlnHour = true;
        for (const item of this.model) {
            migratePlnHour = true;
            for (const subitem of item.items) {
                if (subitem.id === 2) {
                    migratePlnHour = false;

                    continue;
                }

                if (subitem.items.length === 0) {
                    migratePlnHour = false;
                } else {
                    subitem.cutPriceGroups ||= {};

                    const sourceCutPriceGroups = this.model[0]?.items[0]?.cutPriceGroups;

                    if (sourceCutPriceGroups) {
                        for (let i = 2; i <= 7; i++) {
                            subitem.cutPriceGroups[i] = sourceCutPriceGroups[i] ?? null;
                        }
                    }
                }
            }

            if (migratePlnHour) {
                item.cutPriceGroups ||= {};

                const sourceCutPriceGroups = this.model[0]?.items[0]?.cutPriceGroups;

                if (sourceCutPriceGroups) {
                    for (let i = 2; i <= 7; i++) {
                        item.cutPriceGroups[i] = sourceCutPriceGroups[i] ?? null;
                    }
                }
            }
        }
    }

    findSimilarCutCosts(size) {
        if (!size) {
            return false;
        }

        let returnValue = false;

        for (const defaultSize of this.model[0].items[0].items) {
            if (size.value === defaultSize.value) {
                return defaultSize;
            }
        }

        return returnValue;
    }

    migrateCutCost(fromSize, toSize) {
        const cutModes = [
            {
                name: "Laser",
                tag: "laser"
            },
            {
                name: "Piła",
                tag: "chain"
            },
            {
                name: "Polerowanie",
                tag: "chainPolished"
            },
            {
                name: "Frez",
                tag: "frez"
            }
        ];

        for (const priceGroup of this.priceGroups) {
            if (priceGroup.id === 1) {
                continue;
            }

            for (const cutMode of cutModes) {
                toSize.childCutPriceGroups ||= {};
                toSize.childCutPriceGroups[priceGroup.id] ||= {};
                toSize.childCutPriceGroups[priceGroup.id][cutMode.tag] ||= {};

                toSize.childCutPriceGroups[priceGroup.id][cutMode.tag][5] = 
                    fromSize.childCutPriceGroups?.[priceGroup.id]?.[cutMode.tag]?.[5] ?? 1.01;
            }
        }
    }
}

let materialsComponent = {
    bindings: {},
    template: materialsHtml,
    controller: materialController
};

export default materialsComponent;
